import React from 'react';
import {
  Grid,
  Button,
  Typography,
  Modal
} from '@material-ui/core';
import { Edit, Close } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import withRoot from '../../withRoot';
import { I18n } from '../../i18n/';
import { Link, Redirect } from 'react-router-dom';

const styles = theme => ({
  root: {
    textAlign: 'left',
    width: '94%',
    margin: '30px 3%',
  },
  modal: {
    position: 'absolute',
    width: theme.spacing.unit * 150,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    left: '50%',
    height: '90vh',
    overflowY: 'auto',
    top: '50%',
    transform: `translate(-50%, -50%)`,
    '& a': {
      textDecoration: 'none'
    }
  },
  textField: {
    width: '100%',
    marginBottom: '20px'
  },
  alignRight: {
    textAlign: 'right'
  },
  data: {
    '& h4': {
      marginBottom: '0'
    }
  }
});


class ItemView extends React.Component {
  state = {
    open: true,
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  renderRedirect = () => {
      if (!this.state.open) {
        return <Redirect to='/cso-grants' />
      }
  }

  render() {
      const { classes, item, lang } = this.props;
      return (
        <>
          {this.renderRedirect()}
          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.state.open}
            onClose={this.handleClose}
          >
            <div className="modal">
              <a className="close" onClick={this.handleClose}>
                <Close/>
              </a>
              <Grid container spacing={24} alignItems='center'>
                <Grid item xs={6}>
                  <Typography gutterBottom variant="h2" component="h2" style={{'color': '#fdbb2d'}}>
                    {I18n[lang].csoGrants.csoGrant} {item.id}
                  </Typography>
                </Grid>
                <Grid item xs={6} className={classes.alignRight}>
                  <Link to={`/cso-grants/edit/${item.id}`}>
                    <Button variant="contained" color="primary">
                      <Edit />
                      {I18n[lang].csoGrants.edit}
                    </Button>
                  </Link>
                </Grid>
              </Grid>
              <Typography className={classes.data}>
                <h4>{I18n[lang].csoGrant.year}</h4>
                <p>{item.year}</p>
                <h4>{I18n[lang].csoGrant.projectTitle}</h4>
                <p>{item.projectTitle}</p>
                <h4>{I18n[lang].csoGrant.cso}</h4>
                <p>{item.cso}</p>
              </Typography>
            </div>
          </Modal>
        </>
      );
  }
}

export default withRoot(withStyles(styles)(ItemView));
